import * as React from 'react';
import { HeaderBase, MyLoadingComponent } from './components';
import { observer } from 'mobx-react';
import XLH5SDK from './com/xh5';
import {
    clearCookie,
} from './utils';
import store, { StatusStore } from './store';
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';
import { Route, HashRouter as Router, Redirect } from 'react-router-dom';
import './App.less';

const Home: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/index/home/Home'),
});

const AppDetail: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/index/appdetail/AppDetail'),
});

const VideoDetail: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/videoDetail/VideoDetail'),
});

const GoBuy: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/shops/gobuy/GoBuy'),
});

const PayOk: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/shops/payok/PayOk'),
});

const Shop: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/shops/shop/Shop'),
});

const Add: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/adds/add/Add'),
});

const EditAdd: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/adds/editadd/EditAdd'),
});

const my: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/my/my'),
});

const Order: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/order/Order'),
});

const OrderDetails: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/orderdetails/OrderDetails'),
});

const login: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/login/login'),
});

const LogisticsDetail: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/logisticsDetail/logisticsDetail'),
});

const SearchResult: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/search/searchResult/searchResult'),
});

const SearchStart: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/search/searchStart/searchStart'),
});

const SpecialPage: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/activitys/special/Special'),
});

const Classification: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/classification/Classification'),
});

const CouponCollection: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/coupons/couponCollection/CouponCollection'),
});

const CouponList: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/coupons/couponList/couponList'),
});

const ThematicList: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/activitys/thematicList/ThematicList'),
});

const PersonalInfo: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/personalInfo/PersonalInfo'),
});

const PurchaseBuy: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/giftBag/purchaseBuy/PurchaseBuy'),
});

const GiftBagList: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/giftBag/my/my'),
});

const PurchaseStatus: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/giftBag/purchaseStatus/PurchaseStatus'),
});

const GameLogin: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/gameInsert/gamelogin/GameLogin'),
});

const QrshareDialog: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/qrshareDialog/QrshareDialog'),
});

const OnlineService: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/onlineservice/onlineservice'),
});

const Invitation: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/giftBag/invitation/invitation'),
});

const NewPurchase: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/newPurchase/NewPurchase'),
});

const HelpCenter: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/helpCenter/helpCenter'),
});

const RegisterVipStatusPage: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/registerVipStatusPage/RegisterVipStatusPage'),
});

const RegisterVipPage: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/registerVipPage/RegisterVipPage'),
});

const TransferPage: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/registerVipPage/TransferPage'),
});

const TryShopOwner: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/giftBag/tryShopOwner/tryShopOwner'),
});

const AddReturnOrder: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/returnOrder/AddReturnOrder'),
});

const Evaluate: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/mys/evaluate/Evaluate'),
});

const EvaluateList: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/index/evaluateList/evaluateList'),
});

const LoginPage: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/loginPage/LoginPage'),
});

const PayType: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/payType/payType'),
});

const Download: Loadable = Loadable({
    loading: MyLoadingComponent,
    loader: () => import('./pages/download/download'),
});

interface IAppPropType {
    status?: StatusStore;
    prefixCls?: string;
}

interface IAppState {
    gameApp?: string;
}

@observer
class App extends React.Component<IAppPropType, IAppState> {
    public static defaultProps = {
        prefixCls: 'app'
    };

    public static contextTypes = {
        router: PropTypes.object
    };

    public constructor(props: IAppPropType, context: any) {
        super(props, context);
        this.state = {
            gameApp: ''
        };
    }

    public componentWillMount() {
        // 通过域名判断是否显示头部组件
        if (store.status.gameApp) {
            store.status.isShowHead = true;
            setTimeout(() => {
                // 获取html节点
                const html = document.getElementsByTagName('html')[0];
                // 获取屏幕宽度
                const pageWidth = html.getBoundingClientRect().width;
                // 屏幕宽度 / 固定数值 = 基准值
                html.style.fontSize = pageWidth / 37.5 + 'px';
                var deviceWidth = document.documentElement.clientWidth;
                if (deviceWidth >= 1080) { deviceWidth = 1080; }
                document.documentElement.style.fontSize = deviceWidth / 38 + "px";
            }, 3000);
        }
    }
    public render(): React.ReactNode {
        return (
            <Router hashType="hashbang">
                <div style={{ height: "100%" }}>
                    {
                        (store.status.isShowHead && !store.status.isGameAppdetail) && <HeaderBase
                            title={store.status.appTitle}
                            btn={store.status.rightBtnType}
                            onBack={this.onBack}
                            onBtnRightClick={this.onBtnRightClick}
                        />
                    }
                    <Route path="/" exact={true} render={() => <Redirect to="/home" />} />
                    {<Route path="/home" exact={true} component={Home} />}
                    {<Route path="/appdetail/:id" exact={true} component={AppDetail} />}
                    {<Route path="/appdetail/:id/:isindex" exact={true} component={AppDetail} />}
                    {<Route path="/videoDetail" exact={true} component={VideoDetail} />}
                    {<Route path="/shop" exact={true} component={Shop} />}
                    {<Route path="/gobuy/:id/:source/:selectNum" exact={true} component={GoBuy} />}
                    {<Route path="/payok/:id/:oid" exact={true} component={PayOk} />}
                    {<Route path="/add" exact={true} component={Add} />}
                    {<Route path="/add/:id/:source" exact={true} component={Add} />}
                    {<Route path="/editadd" exact={true} component={EditAdd} />}
                    {<Route path="/editadd/:id" exact={true} component={EditAdd} />}
                    {<Route path="/editadd/:id/:source" exact={true} component={EditAdd} />}
                    {<Route path="/my" exact={true} component={my} />}
                    {<Route path="/login" exact={true} component={login} />}
                    {<Route path="/order/:id" exact={true} component={Order} />}
                    {<Route path="/orderdetails/:id" exact={true} component={OrderDetails} />}
                    {<Route path="/logisticsDetail/:id/:name/:phone/:orderId" exact={true} component={LogisticsDetail} />}
                    {<Route path="/searchResult/:val" exact={true} component={SearchResult} />}
                    {<Route path="/searchResult/:couponId/:useType" exact={true} component={SearchResult} />}
                    {<Route path="/searchResult/:val/:type/:id" exact={true} component={SearchResult} />}
                    {<Route path="/searchStart" exact={true} component={SearchStart} />}
                    {<Route path="/specialPage/:id" exact={true} component={SpecialPage} />}
                    {<Route path="/classification" exact={true} component={Classification} />}
                    {<Route path="/couponCollection/:shareId" exact={true} component={CouponCollection} />}
                    {<Route path="/couponList/:id" exact={true} component={CouponList} />}
                    {<Route path="/thematicList" exact={true} component={ThematicList} />}
                    {<Route path="/giftBagList" exact={true} component={GiftBagList} />}
                    {<Route path="/purchaseStatus/:status" exact={true} component={PurchaseStatus} />}
                    {<Route path="/tryShopOwner" exact={true} component={TryShopOwner} />}
                    {<Route path="/purchaseBuy/:id" exact={true} component={PurchaseBuy} />}
                    {<Route path="/personalInfo" exact={true} component={PersonalInfo} />}
                    {<Route path="/invitation" exact={true} component={Invitation} />}
                    {<Route path="/transferPage" exact={true} component={TransferPage} />}
                    {<Route path="/gameLogin" exact={true} component={GameLogin} />}
                    {<Route path="/qrshareDialog" exact={true} component={QrshareDialog} />}
                    {<Route path="/onlineservice" exact={true} component={OnlineService} />}
                    {<Route path="/newPurchase" exact={true} component={NewPurchase} />}
                    {<Route path="/helpCenter" exact={true} component={HelpCenter} />}
                    {<Route path="/registerVipStatusPage/:status" exact={true} component={RegisterVipStatusPage} />}
                    {<Route path="/registerVipPage" exact={true} component={RegisterVipPage} />}
                    {<Route path="/addReturnOrder" exact={true} component={AddReturnOrder} />}
                    {<Route path="/evaluate/:id" exact={true} component={Evaluate} />}
                    {<Route path="/evaluateList/:id" exact={true} component={EvaluateList} />}
                    {<Route path="/loginPage/:type" exact={true} component={LoginPage} />}
                    {<Route path="/payType" exact={true} component={PayType} />}
                    {<Route path="/download" exact={true} component={Download} />}
                </div>
            </Router>
        );
    }

    @autobind
    private onBack(): void {
        history.back();
    }

    @autobind
    private onBtnRightClick(): void {
        if (store.status.rightBtnType === 'backHall') {
            XLH5SDK.closeWebView();
            clearCookie('isLoaded');
        }
    }
}

declare var window: any;
window.ajaxTime = new Date();
export default App;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx